import React from 'react';
import './styles.css'
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";


const Tile = [
  {
    img:"Test", 
    name:"Leadership Coaching", 
    description:"Challenging and encouraging conversations", 
    link:"Test"
  },
  {
    img:"Test", 
    name:"Collaboration Events", 
    description:"Increase collaboration across boundaries", 
    link:"Test"
  },
  {
    img:"Test", 
    name:"Thrive Programme", 
    description:"Increase personal well-being and flourish", 
    link:"Test"
  }
]

const Homepage = () => {
  return (
    <div >
      <img className="Main-photo" alt='vee' src={'/images/photos/homepageVM.webp'} />
      <h1>Enabling you, your team and your organisation to thrive</h1>
      <Container>
        <Row className='About'>
            <h2>
              What We Are About
            </h2>
            <p>
              We believe the greatest power for change is through talking about what we care about, what really matters, what’s real.

              We love to support the process of realising the potential of individuals, teams and communities.

              Learning, collaborating, understanding, compassion, gaining insights, building on our strengths, engaging is what’s important to us.

              We do this through individual leadership coaching, Thrive well-being programmes and large-scale collaborative events.
            </p>
        </Row>
      </Container>
        <div className='WhatWeDo'>
          <Container>
            <Row>
              {Tile.map(data => {
              return (
                <Col key={data.name} className="Tile-class">
                  <span><i></i></span>
                    <div className='white-bubble'>
                      <h2>{data.name}</h2>
                      <h6>{data.description}</h6>
                    </div>
                    <Link to={"/courses"}>
                      <button>Find out more</button>
                    </Link>
                </Col>)})}
              </Row>
          </Container>
        </div>
        <Container>
        <Row className='About'>
          <Col>
            <h2>
              Clients Come To Us Because
            </h2>
            <ul>
              <li>    
              They are facing complexity and uncertainty and need to transform the ways they work and this is proving harder than they thought.
              </li><li>
              Habitual ways of working are no longer bringing the desired outcomes.
              </li><li>
              Its hard to find meaning and purpose within their current workplace setting.
              </li><li>
              Work practices are stressful, they have tried all the obvious routes to finding a calmer and more balanced way to live.
              </li><li>
              They want to become more resilient and find better ways to work under pressure.
              </li><li>
              They want to catalise engagement, and collaboration within an organisation or across organisations by bringing diverse groups together.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Homepage;